module.exports = __webpack_public_path__ + "web/img/card.d5bab4fa.png";